// extracted by mini-css-extract-plugin
export default {"root":"BackTitle_root__NryDh","title":"BackTitle_title__XdnbC"};